<template>
  <v-menu
    v-if="!loading"
    :data-qa="dataQa + '-menu-root'"
    left
    offset-x
    offset-y>
    <template #activator="{ on }">
      <div
        class="ml-auto"
        :data-qa="dataQa + '-menu-activator'"
        v-on="on"
        @click.prevent="">
        <sButton
          :data-qa="dataQa + '-menu-btn'"
          :disabled="loading || disabled"
          icon="menu"
          small
          type="text"/>
      </div>
    </template>
    <div
      class="purch-card-menu menu"
      :data-qa="dataQa + '-menu-list'"
      dense>
      <MenuItem
        v-for="(menu_item, index) in menu_list"
        :key="index"
        :data-qa="`${dataQa}-menuitem-${menu_item.icon}-${index}`"
        :icon="menu_item.icon"
        :label="menu_item.text"
        @click="menu_item.click"/>
    </div>
  </v-menu>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'

import GroupOfAccreditationsApi from '@/api/groupOfAccreditationsApi'
const api = new GroupOfAccreditationsApi()

import textFunctions from 'mixins/textFunctions'

export default {
  name: 'GroupOfAccreditationMenu',
  mixins: [
    textFunctions,
  ],
  methods: {
    copyGroupOfAccreditation() {
      this.$router.push({ name: 'groupOfAccreditationNew', query: { duplicate: this.item.id }, params: { org: this.$route.params.org } })
    },
    onEdit() {
      this.$router.push({ name: 'groupOfAccreditationEdit', params: { id: this.itemId, org: this.$route.params.org } })
    },
    onDuplicate() {
      this.$router.push({ name: 'groupOfAccreditationNew', query: { duplicate: this.itemId }, params: { org: this.$route.params.org } })
    },
    async onPublish() {
      await api.publishAccreditationGroup(this.itemId)
        .then((result) => {
          if (result) {
            this.$emit('publish', this.itemId)
          }
        })
    },
    async onDeactivate() {
      await api.archiveAccreditationGroup(this.itemId)
        .then((result) => {
          if (result) {
            this.$emit('deactivate', this.itemId)
          }
        })
    },
  },
  computed: {
    itemId() {
      return this.item?.id
    },
    menu_list() {
      let opts =  []
      
      if (this.item.status === 'DRAFT') {
        opts.push({text: this.$_capitalizeFirstLetter((this.$t('Tenders.Publish'))), icon: 'continue', click: this.onPublish})
        opts.push({text: this.$t('Common.Edit'), icon: 'edit', click: this.onEdit})
      }
      opts.push({text: this.$t('Catalog.Duplicate'), icon: 'docs', click: this.onDuplicate})
      if (this.item.status !== 'ARCHIVE') {
        opts.push(
          {text: this.$t('Common.Archive'), icon: 'cancel', click: this.onDeactivate}
        )
      }
      return opts
    },
  },
  components: {
    MenuItem,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    dataQa: {
      type: String,
      default: 'group-of-accreditation-menu'
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
}
</script>
